import { defineComponent as u, mergeModels as c, useModel as p, computed as i, createBlock as f, openBlock as x, unref as o, withCtx as m, createVNode as d, createElementVNode as w, toDisplayString as V } from "vue";
import { ScalarListbox as b, ScalarButton as g } from "@scalar/components";
import { ScalarIconCaretDown as h } from "@scalar/icons";
const v = { class: "min-w-0 flex-1 truncate" }, k = /* @__PURE__ */ u({
  __name: "ExamplePicker",
  props: /* @__PURE__ */ c({
    examples: { default: () => ({}) }
  }, {
    modelValue: {
      required: !0
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(s) {
    const n = p(s, "modelValue"), r = i(
      () => Object.entries(s.examples).map(([e, t]) => ({
        id: e,
        label: (t == null ? void 0 : t.summary) ?? e
      }))
    ), l = i({
      get: () => r.value.find(({ id: e }) => e === n.value),
      set: (e) => n.value = (e == null ? void 0 : e.id) ?? ""
    });
    return (e, t) => (x(), f(o(b), {
      modelValue: l.value,
      "onUpdate:modelValue": t[0] || (t[0] = (a) => l.value = a),
      class: "w-fit min-w-32",
      options: r.value,
      placement: "bottom-start"
    }, {
      default: m(() => [
        d(o(g), {
          class: "text-c-2 hover:text-c-1 flex h-full w-fit min-w-0 gap-1.5 px-1.5 py-0.75 text-base font-normal",
          "data-testid": "example-picker",
          fullWidth: "",
          variant: "ghost"
        }, {
          default: m(() => {
            var a;
            return [
              w("div", v, V(((a = l.value) == null ? void 0 : a.label) ?? "Select an example"), 1),
              d(o(h), {
                class: "ui-open:rotate-180 mt-0.25 size-3 transition-transform duration-100",
                weight: "bold"
              })
            ];
          }),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "options"]));
  }
});
export {
  k as default
};
